import Controller from "controllers/application_controller"

export default class extends Controller {
  static identifier = "modal"

  connect() {
    this.addEventListener('cancel', event => this.didCancel(event))
    this.addEventListener('close', event => this.didClose())
  }

  closeFromBackdrop(event) {
    // Close if click was directly on the dialog (outside wrapper)
    if (event.target === this.element) {
      this.element.close()
    }
  }

  didClose() {
    this.element.remove()
  }

  didCancel(event) {
    event.preventDefault()
  }

  // Dialogs can only be closed by cancelling or confirming. We intercept clicks outside of the

  // handleClickOutside(event) {
  //   if (this.isDirectClickOutside(event)) {
  //     event.stopPropagation()
  //   }
  // }

  // /**
  //  * It is not possible to determine if the click is on the <dialog> backdrop,
  //  * but the click is still fired to the dialog element directly as the target.
  //  * This method checks if the click is outside the dialog element.
  //  */
  // isDirectClickOutside(event) {
  //   // Only proceed if this is a mouse event
  //   if (event instanceof MouseEvent && event.target === this.element) {
  //     let rect = this.element.getBoundingClientRect();
  //     if (rect.left > event.clientX ||
  //         rect.right < event.clientX ||
  //         rect.top > event.clientY ||
  //         rect.bottom < event.clientY
  //     ) {
  //       return true
  //     }

  //     return false
  //   }
  // }
}
